import React from 'react';
import PropTypes from 'prop-types';
import { getEntityUrl } from '@culture/utils/helpers/entities';
import EntityPropTypes from 'propTypes/entities';

import {
	cardCropTextDefault,
	imageCardSizeDefault
} from 'utils/helpers/entities';

import BaseCard from './BaseCard';

const ObjectCard = ({
	className,
	cropTextParams,
	entity,
	onFocus,
	params,
	typeWidth
}) => {
	const { title, thumbnailFile } = entity;

	const url = getEntityUrl('objects', entity);

	return (
		<BaseCard
			{...{
				className,
				cropTextParams,
				onFocus,
				params,
				thumbnailFile,
				title,
				typeWidth,
				url
			}}
		/>
	);
};

ObjectCard.propTypes = {
	className: PropTypes.string,
	cropTextParams: PropTypes.shape({
		title: PropTypes.string
	}),
	entity: EntityPropTypes.publication.isRequired,
	onFocus: PropTypes.func,
	params: PropTypes.shape({
		width: PropTypes.number.isRequired,
		height: PropTypes.number.isRequired
	}),
	typeWidth: PropTypes.oneOf([
		'fluidLandscapeSlide',
		'fixedLandscape',
		'landingLandscape'
	])
};

ObjectCard.defaultProps = {
	cropTextParams: cardCropTextDefault,
	params: imageCardSizeDefault.landscape
};

export default ObjectCard;
